import { render, staticRenderFns } from "./detailPop.vue?vue&type=template&id=972c86fe&"
import script from "./detailPop.vue?vue&type=script&lang=js&"
export * from "./detailPop.vue?vue&type=script&lang=js&"
import style0 from "./detailPop.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports